import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CreateUpdateTray from "pages/vending/tray/CreateUpdateTray";
import React from "react";

const TrayCrudDialog = ({
  open,
  handleClose,
  number,
  cabin_id,
  setCurrentItem,
  tray,
}) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={() => {
        handleClose();
        setCurrentItem(null);
      }}
      heading={tray ? "Update tray" : "Create tray"}
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        <CreateUpdateTray cabin_id={cabin_id} number={number} tray={tray} />
      </Box>
    </CustomDialog>
  );
};

export default TrayCrudDialog;
